import { Typography } from "@mui/material";
import { Routes } from "config";
import React from "react";
import { Breadcrumbs } from "./Breadcrumbs";

export const PageHeader = (props: PageHeaderProps) => {
  const { title, actions, pageName, leftElement } = props;

  return (
    <div className="layout-page-header">
      <div className="_d-flex-ali-center-sm-gap">
        <Breadcrumbs pageName={pageName} />
        {typeof title === "string" ? <Typography variant="h3" mr={1}>{title}</Typography> : title}
        {leftElement}
      </div>

      <div className="_d-flex-ali-center-md-gap">{actions}</div>
    </div>
  );
};

interface PageHeaderProps {
  title: React.ReactNode;
  pageName: Routes;
  actions?: React.ReactNode;
  leftElement?: React.ReactNode;
}
